import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionEditForm } from "./components/DigestionEditForm";

export function EditDigestionPage() {
  return (
    <Page title="Edit Digestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionEditForm />
      </Container>
    </Page>
  );
}
